module.exports = __webpack_public_path__ + "static/media/top.05b9442d.png";


//////////////////
// WEBPACK FOOTER
// ./src/safetyTrainingExam/images/top.png
// module id = 1413
// module chunks = 0